import { Drawer, Grid } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { FormControlsArrowKeysFix } from "~Components/form/formControlsArrowKeysFix"
import { DeliveryNoteForm } from "~Features/pages/deliveryNotes/components/DeliveryNoteForm"
import { onCloseDrawer } from "~Features/pages/purchaseOrders/drawer/drawer.utils"
import { type PurchaseOrderReference } from "~Shared/models/purchaseOrderReference"
import { type DeliveryNote } from "../types/deliveryNote.interfaces"
import { type InboxDeliveryNoteFormProps } from "./DeliveryNoteForm"

const { useBreakpoint } = Grid

type DeliveryNoteDrawerProps = {
    open: boolean
    onClose: () => void

    /** `true` when editing an existing delivery note, `false` when creating a new one. */
    editMode: boolean

    /** The delivery note to be edited, omit when creating a new one. */
    deliveryNote?: DeliveryNote

    /** Use when directly adding a delivery note to a PO from the PO details page, omit otherwise. */
    preSelectedPurchaseOrder?: PurchaseOrderReference
} & InboxDeliveryNoteFormProps

export const DeliveryNoteDrawer = ({ open, onClose, editMode, deliveryNote, preSelectedPurchaseOrder, inboxDeliveryNote, onCreatedFromInbox }: DeliveryNoteDrawerProps) => {
    const { t } = useTranslation()
    const screens = useBreakpoint()
    const onCloseDeliveryNoteDrawer = () => {
        onClose()
    }

    const getTitle = () => {
        if (editMode) {
            return t("deliveryNote:drawer.editDeliveryNote")
        }
        if (preSelectedPurchaseOrder) {
            return t("deliveryNote:drawer.newDeliveryNoteForPo", { poNumber: preSelectedPurchaseOrder.purchaseOrderNumber })
        }
        return t("deliveryNote:drawer.newDeliveryNote")
    }

    return (
        <FormControlsArrowKeysFix>
            <Drawer
                {...{
                    open,
                    title: <span>{getTitle()}</span>,
                    destroyOnClose: true,
                    placement: "right",
                    width: screens.xxl ? "1500px" : "800px",
                    closable: true,
                    keyboard: true,
                    "data-testid": "finway:deliveryNote:drawer",
                    onClose: onCloseDrawer(onCloseDeliveryNoteDrawer),
                }}
            >
                {open && (
                    <DeliveryNoteForm // keep line breaks
                        {...{
                            editMode,
                            deliveryNote,
                            onCancel: onCloseDeliveryNoteDrawer,
                            preSelectedPurchaseOrder,
                            inboxDeliveryNote,
                            onCreatedFromInbox,
                        }}
                    />
                )}
            </Drawer>
        </FormControlsArrowKeysFix>
    )
}
